//GeneratorFlag:[NoChange]
import routes from './routes'
import services from './services'
import resources from './resources'
import toolbar from './toolbar'

const aut = {
	name: 'aut',
	foldreName: 'aut',
	routes,
	services,
	resources,
	toolbar
}

export default aut
export { routes, services, resources, toolbar }